export enum TaxMode {
    Overview = 'overview',
    Questionnaire = 'questionnaire',
}
